import { render, staticRenderFns } from "./AgateProject.vue?vue&type=template&id=79f3e1ec&"
import script from "./AgateProject.vue?vue&type=script&lang=js&"
export * from "./AgateProject.vue?vue&type=script&lang=js&"
import style0 from "./AgateProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports